import request from '@/utils/request'

/**
 * data:{}
 * @param {*} username 账号
 * @param {*} password 密码
 * @param {*} uuid 前端随机生成的id
 * @param {*} captcha 验证码
 * @returns 
 */

export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: data
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/admin/update',
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}


export function updatePassword(data) {
  return request({
    url: '/admin/updatePassword',
    method: 'post',
    data: data
  })
}
export function getCodeImgApi(uuid) {
  return request({
    url: '/admin/captcha.jpg?uuid='+uuid,
    method: 'get',
    responseType: 'blob'
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js